// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"141":"b37f4dbb","591":"fb465226"}[chunkId] + ".chunk.css";
};